import React from 'react'

const ListItem: React.FC = ({ children }) => {
  return <li className="ml-8 mt-2">{children}</li>
}

export default ListItem
